import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import {IProductCatalogRestService} from "./product-catalog-rest";
import type {IProductCatalog} from "../model/domain/ProductCatalog";
import { IResponse } from "@core/data-access/model";

 export class ProductCatalogRestService extends AbstractAccessorService<IProductCatalog> implements IProductCatalogRestService{
    public readonly $name: string = "productCatalogRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IProductCatalog>) {
        super();
    }
    
    getDefaultCatalog(): angular.IPromise<IResponse<IProductCatalog>> {
        return this.$accessor<IProductCatalog, "getDefaultCatalog">(this.$name, "getDefaultCatalog");
    }
 }